<template>
  <div class="hm-collections-box">
    <div class="title-box">
      {{value.title}}
    </div>
    <div class="hm-collections-con">
      <el-row>
        <el-col :span="12" v-for="(item, index) of value.goods" :key="index">
          <div class="hm-collections-item">
            <div class="hm-collections-item__pic">
              <sp-image :src="item.imgUrl" :circle="0" />
            </div>
            <div class="hm-collections-item__title">
              <div class="title">
                {{item.title}}
              </div>
              <div class="subtitle">
                {{item.subtitle}}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import config from './config'
export default {
  name: "HmCollections",
  wgtName: 'HmCollections',
  wgtDesc: 'hmCollections',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
}
</script>
<style scoped lang="scss">
.hm-collections-box{
  .hm-collections-item{
    padding-bottom: 64px;
    background: white;
    &__pic{
      height: 280px;
    }
    &__title{
      padding: 16px 16px 0;
      >.title{
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 0.28px;
        text-transform: uppercase;
      }
      >.subtitle{
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.14px;
        text-transform: uppercase;
      }
    }
  }
  .title-box{
    padding: 0 16px 16px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.14px;
    text-transform: uppercase;
    background: white;
  }
}
</style>
